import { createAction, props } from '@ngrx/store'

export enum FilterTypes {
  RESET = '[FILTER TYPE] Reset',
  CHANGE_DATE = '[FILTER TYPE] Change Date',
  CHANGE_TYPE = '[FILTER TYPE] Change Type',
  CHANGE_STATUS = '[FILTER TYPE] Change Status',
  CHANGE_NAME = '[FILTER TYPE] Change Name',
}

export const FilterActions = {
  resetAction: createAction(FilterTypes.RESET),
  changeDateAction: createAction(FilterTypes.CHANGE_DATE, props<{ payload: string }>()),
  changeTypeAction: createAction(FilterTypes.CHANGE_TYPE, props<{ payload: string }>()),
  changeStatusAction: createAction(FilterTypes.CHANGE_STATUS, props<{ payload: string }>()),
  changeNameAction: createAction(FilterTypes.CHANGE_NAME, props<{ payload: string }>()),
} as const
